import * as api from "@/api/williams/search";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";
import { IncompleteItemsSearchFilters } from "@/api/williams/search";

export function useIncompleteItems(filters: Partial<IncompleteItemsSearchFilters> = {}) {
  filters = { skip: 0, take: 100, ...filters };

  return useQuery(queryKeys.search.incomplete(filters), () => {
    return api.getIncompleteItems(filters);
  });
}
